<template>
  <div class="cp-modal" :class="{overlay: modal.show && modal2.show}">
    <slot />
  </div>
</template>
<style rel="stylesheet/stylus" lang="stylus" scoped>
@import '../../assets/stylus/minixs/_center.styl';
  .cp-modal
    width: 100%
    height 100%
    top 0
    left 0
    right 0
    bottom 0
    display flex
    justify-content center
    align-items center
    position fixed
    z-index 2000
    background-color rgba(0, 0, 0, 0.85)
    &.overlay
      background-color rgba(0, 0, 0, 0.5)
</style>
<script>
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import { mapState } from 'vuex';

export default {
  beforeMount() {

  },
  computed: {
    ...mapState({
      modal: state => state.modal,
      modal2: state => state.modal2
    })
  },
  mounted() {
    document.body.style.overflow = 'hidden'
  },
  destroyed() {
    document.body.style.overflow = 'auto'
  },
  methods: {
    handleClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
}
</script>

